export enum CacheKey {
    USER_SESSION = "USER_SESSION"
}